module.exports = __webpack_public_path__ + "static/bg_solutions_chewei.cf814985.jpg";